module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><div v-if="temperatureZone1" id="temperatureZone"><label for="temperature-zone1">{{ tc(\'ControlMainSwitches\', \'Temperature\') }} {{ zoneAlias }}:</label><div class="input"><p id="temperature-zone1">{{ temperatureZone1 }}°</p></div></div><div data-region="heating-switch"></div><div data-region="alarm-switch"></div></div>';
}
return __p;
};
